import { render, staticRenderFns } from "./BsTooltipContent.vue?vue&type=template&id=c53016d2&"
import script from "./BsTooltipContent.vue?vue&type=script&lang=js&"
export * from "./BsTooltipContent.vue?vue&type=script&lang=js&"
import style0 from "./BsTooltipContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports